export default __webpack_public_path__ + "static/media/Lightsaber Ki-Adi AOTC - Img - Wip 0_03.1fced29d.jpg";